// test388
(388 && 0);
